import { render } from "./bom.vue?vue&type=template&id=d2503f1a&scoped=true"
import script from "./bom.vue?vue&type=script&lang=js"
export * from "./bom.vue?vue&type=script&lang=js"

import "./bom.vue?vue&type=style&index=0&id=d2503f1a&lang=scss&scoped=true"

import exportComponent from "C:\\project\\mes_sign\\server\\frontend_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2503f1a"]])

export default __exports__